import { render, staticRenderFns } from "./Pdf.vue?vue&type=template&id=198a68ae"
import script from "./Pdf.vue?vue&type=script&lang=js"
export * from "./Pdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('198a68ae')) {
      api.createRecord('198a68ae', component.options)
    } else {
      api.reload('198a68ae', component.options)
    }
    module.hot.accept("./Pdf.vue?vue&type=template&id=198a68ae", function () {
      api.rerender('198a68ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/util/Pdf.vue"
export default component.exports